import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogleSession } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await completeGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (err) {
        setError(apiErr(err));
      }
    })();
  }, [location.hash, completeGoogleSession, navigate]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-red-600 font-medium mb-3">{error}</p>
          <button onClick={() => navigate("/login")} className="text-navy font-semibold hover:text-gold" data-testid="callback-retry">
            Back to Login
          </button>
        </div>
      ) : (
        <p className="text-slate-400" data-testid="callback-loading">Signing you in with Google…</p>
      )}
    </div>
  );
}
